import "./Home3.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Features from "./sections/Features";
import Footer from "@/reusable_sections/Footer";
export default function Home3Page() {
  return <div>
      <Header />
      <Hero />
      <Features />
      <Footer />
    </div>;
}